import LiveClassSchedule from './LiveClassSchedule';
import './LiveClasses.css';

/** Vista consumo: solo calendario (filtros, inscripción, Zoom). Sin programación ni cabecera extra. */
export default function LiveClasses({
  programId,
  sedeMode = false,
  canCloneWeek = false,
  scopeGymId = null,
}) {
  return (
    <div className="d28d-live-classes surface-readable">
      <LiveClassSchedule
        programId={programId}
        sedeMode={sedeMode}
        canCloneWeek={canCloneWeek}
        scopeGymId={scopeGymId}
      />
    </div>
  );
}
